
import * as React from 'react';
import { useContext } from 'react';
import { Featured } from '../Components/Featured/Featured';
import { Footer } from '../Components/Footer/Footer';
import { HomeCarousel } from '../Components/HomeCarousel/HomeCarousel';
import { ProgramShelf } from '../Components/ProgramShelf/ProgramShelf';
import { VideoShelf } from '../Components/VideoShelf/VideoShelf';
import { SettingsContext } from '../Context';
import { SettingsData } from '../Managers/Settings';


export const Home = () => {

    let settings = useContext<SettingsData>(SettingsContext)

    return(
        <div style={{height: '300vh', width: '100vw'}}>
            <HomeCarousel />
            <ProgramShelf />
            <VideoShelf path="/new/en" title="New Episodes" />
            <VideoShelf path="/new/es" title="New Episodes" />
            <Featured />
            <VideoShelf path="/related/revelation" title="When is Jesus coming again?" />
            <VideoShelf path="/related/health" title={"Healthy, wealthy, and wise"} />
            <VideoShelf path="/related/thursday" title="#Throwback Thursdays" />
            <VideoShelf path="/related/nature" title="Nature is awesome" />

            

            
            <Footer />
        </div>
    )
}